





































import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class UpmindLoginSuccessModal extends Vue {
  // Props

  @Prop({ required: true })
  public domain!: string;

  @Prop({ required: true })
  public url!: string;

  @Prop({ default: () => () => ({}) })
  public focus!: () => Window["focus"];

  @Prop({ default: true })
  public isAdmin!: boolean;

  // Methods

  public goToUrl() {
    return (window.location.href = this.url);
  }
}
